import { render } from "./BookList.vue?vue&type=template&id=07aa8efb&ts=true"
import script from "./BookList.vue?vue&type=script&lang=ts"
export * from "./BookList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__